import React, { Component } from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { find as _find, filter as _filter, map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Types } from '../Themes/Types';

import CollapsibleItem from './CollapsibleItem/CollapsibleItem';

class Collapsible extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSections: [],
    };
    this.handelItemPress = this.handelItemPress.bind(this);
  }

  componentDidMount() {
    const { activeSections } = this.props;
    activeSections && this.setState({ activeSections });
  }

  componentDidUpdate(prevProps) {
    const { activeSections } = this.props;
    if (this.props.activeSections !== prevProps.activeSections) {
      this.setState({ activeSections });
    }
  }

  updateList = (item, list) => {
    if (_find(list, d => d === item)) {
      return _filter(list, d => d !== item);
    }
    return [...list, item];
  };

  handelItemPress = (itemIndex, activeSections) => {
    const _activeSections = this.updateList(itemIndex, activeSections);
    this.setState({ activeSections: _activeSections });
  };
  renderItems = (items, type, activeSections, collapsibleItemContainerStyle) => {
    const listSize = (items || []).length - 1;
    return _map(items, (item, index) => {
      const isOpend = _find(activeSections, d => d === index + 1);
      return (
        <CollapsibleItem
          key={`Collapsible-Item-${index + 1}`}
          {...item}
          status={item.status || null}
          onPress={() => this.handelItemPress(index + 1, activeSections)}
          type={type}
          isLastItem={index === listSize}
          isOpend={isOpend}
          index={index}
          collapsibleItemContainerStyle={collapsibleItemContainerStyle}
        />
      );
    });
  };

  render() {
    const { items, type, collapsibleItemContainerStyle } = this.props;
    const { activeSections } = this.state;
    return (
      <React.Fragment>
        {this.renderItems(items, type, activeSections, collapsibleItemContainerStyle)}
      </React.Fragment>
    );
  }
}

Collapsible.propTypes = {
  items: PropTypes.array,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  activeSections: PropTypes.array,
  collapsibleItemContainerStyle: ViewPropTypes.style,
};
Collapsible.defaultProps = {
  items: [],
  type: Types.PRIMARY,
  activeSections: [],
};

export { Collapsible };

export default Collapsible;
